import { useMemo } from 'react'

import { useExtensionsI18n } from '../i18n/provider'
import { PickList } from './PickList'

export interface UserGroupPickListItem {
  id: number
  name: string
}

interface UserGroupPickListProps {
  allGroups: UserGroupPickListItem[]
  assignedIds: number[]
  onAssignedChange: (ids: number[]) => void
  assignedGroupNames?: Record<number, string>
  disabled?: boolean
}

export function UserGroupPickList({
  allGroups,
  assignedIds,
  onAssignedChange,
  assignedGroupNames = {},
  disabled = false,
}: UserGroupPickListProps) {
  const { text } = useExtensionsI18n()
  const allItems = useMemo(
    () => allGroups.map((group) => ({ id: group.id, label: group.name })),
    [allGroups],
  )

  return (
    <PickList
      allItems={allItems}
      assignedIds={assignedIds}
      onAssignedChange={onAssignedChange}
      assignedLabels={assignedGroupNames}
      itemNoun={text('extensions.edit.userGroupsNoun', 'user groups')}
      disabled={disabled}
    />
  )
}
